import * as Storage from "./Storage";

export function setCurrency(currency) {
  Storage.setItem("currency", currency);
}

export function getCurrency() {
  return Storage.getItem("currency") || "usd";
}
